export enum NotificationCategory {
  transactional = 'transactional',
  marketing = 'marketing',
}

export enum NotificationPreferenceGroup {
  system = 'system',
  social = 'social',
  marketing = 'marketing',
  reminder = 'reminder',
}

export enum NotificationSource {
  template = 'template',
  inline = 'inline',
}

export enum NotificationDisplayDomain {
  generic = 'generic',
  user = 'user',
  training = 'training',
  program = 'program',
  post = 'post',
  comment = 'comment',
  subscription = 'subscription',
  relation = 'relation',
  community = 'community',
  exercise = 'exercise',
  file = 'file',
  system = 'system',
  maintenance = 'maintenance',
  payment = 'payment',
  chat = 'chat',
  marketing = 'marketing',
  reminder = 'reminder',
  calendar = 'calendar',
  workout = 'workout',
  hashtag = 'hashtag',
  sync = 'sync',
  bugReport = 'bugReport',
  notification = 'notification',
}

export interface IMarkNotificationsReadBody {
  ids: string[];
}

export interface IMarkNotificationsReadResponse {
  markedCount: number;
}

export interface IUserNotificationItem {
  id: string;
  source: NotificationSource;
  templateCode: string | null;
  category: NotificationCategory;
  preferenceGroup: NotificationPreferenceGroup;
  displayDomain: NotificationDisplayDomain;
  title: string;
  body: string;
  data: Record<string, unknown> | null;
  readAt: string | null;
  campaignId: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface IListUserNotificationsResponse {
  items: IUserNotificationItem[];
  nextCursor: string | null;
  hasMore: boolean;
}

export interface IUnreadNotificationsCountResponse {
  unreadCount: number;
}

export type INotificationsListQueryArg = {
  limit?: number;
  cursor?: string;
};
